const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://salmon-alligator-521357.hostingersite.com/';
const GLOBAL_CONSTANTS = {
    API_BASE_URL: API_BASE_URL,

    EXTENSION_MIME_TYPE: {
        "xlsx": 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        "docx": 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        "doc": 'application/msword',
        "pdf": 'application/pdf',
        "jpeg": 'image/jpeg',
        "png": 'image/png',
        "jpg": 'image/jpg',
    },

    // EXTENSION_ICON_NAME: {
    //     "xlsx": 'fa-file-excel-o',
    //     "docx": 'fa-file-word-o',
    //     "doc": 'fa-file-word-o',
    //     "pdf": 'fa-file-pdf-o',
    //     "jpeg": 'fa-file-image-o',
    //     "png": 'fa-file-image-o',
    //     "jpg": 'fa-file-image-o',
    // },

}

export default GLOBAL_CONSTANTS;
